import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService, IAslibModalOptions } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';
import { AslibLoadingService } from '@aslib/loading';
import { AslibGridComponent, AslibTitleService } from '@aslib/components';
import { ShowFile } from '../../shared/helpers/show-file';
import { Messages } from '../../shared/helpers/mensages';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { CadastrarValorMensalDistribuicaoService } from '../shared/service/cadastra-valor-mensal-distribuir..service';
import { ExportTypes } from '../../shared/enum/TypeExportReportEnums';
import { DetalheValorMensalDistribuirComponent } from './detalhe-valor-mensal-distribuir/detalhe-valor-mensal-distribuir.component';
import { AlteraValorMensalDistribuicao, CadastraValorMensalDistribuicao } from '../shared/model/cadastra-valor-mensal-distribuir.model';
import { BaseConfig } from '../../shared/service/base-config.service';


type Filtro = {
  anoReferencia: string;
};

@Component({
  selector: 'sarf-consulta-valor-mensal-distribuir',
  templateUrl: './consulta-valor-mensal-distribuir.component.html'
})

export class ConsultaValorMensalDistribuir implements OnInit {
  @ViewChild('grid') grid: AslibGridComponent;
  ValoresFiltro: any[];
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  aslibModal: AslibModalComponent;
  DataInicio: Date;
  showFile: ShowFile;
  exibirGrid:boolean = true;
  filtro: Filtro;
  filtroVazio: Filtro = {
    anoReferencia: ''
  };
  dadosValoresDistribuir: any[] = [];
  dadosCadastraValorMensalDistribuir: AlteraValorMensalDistribuicao;
  
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;
  itemSelecionado: any;
  usuarioLogado: any;
    

  constructor(
    private router: Router,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    protected readonly aslibModalService: AslibModalService,
    private readonly _messages : Messages,
    private readonly cadastrarValorMensalDistribuicaoService: CadastrarValorMensalDistribuicaoService,
    private aslibTitleService: AslibTitleService,
    private cd: ChangeDetectorRef,
    private baseConfig: BaseConfig
  ) {
    modalManagerHelper.parent = this;
    this.showFile = new ShowFile();
    this.aslibModal = new AslibModalComponent(this.aslibModalService);
    this.dadosCadastraValorMensalDistribuir =  new AlteraValorMensalDistribuicao();
    this.usuarioLogado = this.baseConfig.getUsuarioLogado();
  }

//metodos de ciclo de vida do componente
ngOnInit() {
    this.filtro = { ...this.filtroVazio };
    this.dadosOnInitFormulario(this.modalMensagem);
 }
  

ngAfterViewInit() {
  setTimeout(() => {
    this.aslibTitleService.Text = "Valor dos Royalties a Distribuir";
    this.aslibTitleService.SubText = "Consultar"
    this.cd.detectChanges(); 
  });
}
unSubscribe() {
  this._aslibLoadingService.complete();
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
}

//Metodos de ação do componente e uteis
formConsultaRoyalties = new FormGroup({
    dataReferenciaDistribuicao: new FormControl('', Validators.required)
  });

irPraAdicionar(): void {
    this.router.navigate(['/royalts/sarf-cadastra-valor-mensal-distribuir']);
  }
public limparConsulta(){
      this.formConsultaRoyalties.reset();
      this.filtro = { ...this.filtroVazio };
       this.dadosOnInitFormulario(this.modalMensagem);
 }
 setaDados(valorDistribuir: any) {
    this.dadosCadastraValorMensalDistribuir.SequencialValorMensalDistribuicao = valorDistribuir.SequencialValorMensalDistribuicao;
    this.dadosCadastraValorMensalDistribuir.ValorMensalDistribuicao = valorDistribuir.valorMensalDistribuicao;
    this.dadosCadastraValorMensalDistribuir.DataReferenciaDistribuicao = valorDistribuir.DataReferenciaDistribuicao;
    this.dadosCadastraValorMensalDistribuir.LoginUsuario = this.usuarioLogado.Login;
  }

onClose(fechas:boolean){
    this.aslibModal.close(fechas);
  }
   exibirSucesso(mensagem:string){      
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: mensagem,
        type: 'info'
      }
    );
  } 

  exibirError(mensagem:string){            
    this._aslibLoadingService.complete();
    new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: mensagem,
        type: 'Info'
      }
    );
  }

private toMesAno(value: string | Date): string | null {
  if (!value) return null;
  const d = (value instanceof Date) ? value : new Date(value);
  if (isNaN(d.getTime())) return null; // data inválida
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const ano = d.getFullYear();
  return `${mes}/${ano}`;
}

filtrar(grid: AslibGridComponent) {
  this.ValoresFiltro = this.dadosValoresDistribuir;

  if (this.filtro.anoReferencia !== null) {
    this.ValoresFiltro = this.ValoresFiltro.filter(t => {
      if(this.toMesAno(t.DataReferenciaDistribuicao) == this.filtro.anoReferencia){
        return t;}});
  }

  grid.dataset = this.ValoresFiltro;
  if(this.ValoresFiltro.length==0){
    this.exibirError('Não existem registros para os filtros informados!');
  }
}

 //Metodos de interação com serviços
dadosOnInitFormulario(modal: AslibModalComponent){
    this.observerOnIniftFormulario = this.cadastrarValorMensalDistribuicaoService.dadosOnInitFormulario().subscribe(
      retornoRequest => {
        
            const lista = retornoRequest.ListaValorMensalDistribuicaoRoyalty;

            // 🛡️ GARANTE QUE NUNCA É UNDEFINED
            this.dadosValoresDistribuir = Array.isArray(lista) ? lista : [];

        if(retornoRequest.objetoMensagem &&  
          retornoRequest.objetoMensagem.Mensagem !== null &&  
          retornoRequest.objetoMensagem.Mensagem !== '') {
          this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
        }

      },
      () => this.observerOnIniftFormulario.unsubscribe()
    );
  }


editar(conteudo: any, item: any){
  this.itemSelecionado = item;
  const options: IAslibModalOptions = {
      title: 'Detalhes da Valor de Royalties a Distribuir',
      backdrop: 'static',
      footerVisible: false,
      size: 'lg',
      content: conteudo,
      okText:'Salvar',
      cancelarText:'Cancelar',
      okVisible:false,
      cancelarVisible:false
    };    
    

  this.aslibModal.open(options).result.then(
      (ano) => {  
       },
      (cancel) => {
       }
    );  
}
 
 onConfirmPropagar(valorDistribuir: any){
    this.setaDados(valorDistribuir);  

    this._aslibLoadingService.start();
      this.subscription =  this.cadastrarValorMensalDistribuicaoService
        .alterarValorMensalDistribuicao(this.dadosCadastraValorMensalDistribuir)
        .subscribe(          
          data => {
            if(data.Data){
              this.exibirSucesso(data.Message);
              this.aslibModal.close(true);
              this.dadosOnInitFormulario(this.modalMensagem);
            }else{
              this.exibirError(data.Message);
            }        
          },
          (error: any) => {
            this.exibirError(error.Mensagem);
            this._aslibLoadingService.complete();
          },
          () => {
            this.unSubscribe(); 
          }
        );
    
  }
gerarRelatorio() {
    
    this._aslibLoadingService.start();
    this.subscription = this.cadastrarValorMensalDistribuicaoService
      .gerarRelatoriodeValoresaDistribuir(this.dadosValoresDistribuir).subscribe(
        data => {
          this.showFile.Windows(data,ExportTypes.Excel_xls,'ValoresADistribuirRoyalty');
        },
        (error: any) => {
          this._aslibLoadingService.complete();
          new AslibModalComponent(this.aslibModalService).open({
            title: 'ERRO',
            text: this._messages.MN0011,
            type: 'erro'
          });
        },
        () => {
          this.unSubscribe();
        }
      );
    }

excluir(modal:AslibModalService, item): void {
const options: IAslibModalOptions = {
      title: 'Exclusão de item',
      backdrop: 'static',
      text: `Confirma a exclusão do registro atual?`,
      okText: 'Sim',
      cancelarText: 'Não',
      content: null,
      cancelarVisible: true
    };
    modal.open(options).result.then(
      () => {
        
    this.setaDados(item);  

    this._aslibLoadingService.start();
      this.subscription =  this.cadastrarValorMensalDistribuicaoService
        .deletarValorMensalDistribuicao(this.dadosCadastraValorMensalDistribuir)
        .subscribe(          
          data => {
            if(data.Data){
              this.exibirSucesso(data.Message);
              this.dadosOnInitFormulario(this.modalMensagem);
            }else{
              this.exibirError(data.Message);
            }        
          },
          (error: any) => {
            this.exibirError(error.Mensagem);
            this._aslibLoadingService.complete();
          },
          () => {
            this.unSubscribe(); 
          }
        );

      },
      () => {}
    );


}

}



// WEBPACK FOOTER //
// ./src/app/royalts/valor-mensal-distribuir/consulta-valor-mensal-distribuir.component.ts